import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

import { DocumentsService } from '../../services/documents-service/documents.service';


@Component({
  selector: 'mcrit-gestio-documents-filtres',
  templateUrl: 'documents-filtre.component.html',
  styleUrls: ['documents-filtre.component.css'],
  providers: []
})
export class DocumentsFiltersComponent implements OnInit {
  @Input() validFilters: Array<any>;
  @Output() changeFilter = new EventEmitter();

  public filterModel: any;
  public dataLists: Array<any>;
  public state: boolean = true ;

  constructor(public translate: TranslateService, public languageService: LanguageService, private documentsService: DocumentsService) {}

  public sendActiveFilters() {
    const activeFilters = {};
    this.documentsService.valFiltres = {};

    Object.keys(this.filterModel)
      .filter(key => (this.filterModel[key] === 0 || this.filterModel[key] && this.filterModel[key] !== ''))
      .forEach(key => this.documentsService.valFiltres[key] = this.filterModel[key]);

    Object.keys(this.filterModel)
      .filter(key => (this.filterModel[key] === 0 || this.filterModel[key] && this.filterModel[key] !== ''))
      .forEach(key => activeFilters[key] = this.documentsService.valFiltres[key]);

    this.changeFilter.emit(activeFilters);
  }

  public resetActiveFilters() {
    const newFilter = {};
    for (let key of this.filterModel)newFilter[key] = null;
    this.documentsService.valFiltres={};
    this.filterModel = newFilter;
    this.sendActiveFilters();
  }

  ngOnInit() {
    let requestedAutocompletes = [];
    //if(!this.validFilters.reduce){this.validFilters = null;return;}
    this.filterModel = this.validFilters.reduce((acum, curr) => {
      curr.inputs.forEach(inputGroup => {
        switch (inputGroup.type) {
          case 'select':
            acum[inputGroup.name] = (inputGroup.value ? inputGroup.value : null);
            break;
          default:
            inputGroup.values.forEach(input => {
              if (input.autocomplete)requestedAutocompletes.push(input.autocomplete);
              acum[input.name] = (input.value ? input.value : null);
            });
        }
      });
      return acum;
    }, {});

    this.dataLists = requestedAutocompletes.map(id => {
      return {
        id: id,
        options: this.documentsService.getAutocomplete(id)
      };
    });
    this.sendActiveFilters();
  }
}
